var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F22222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68216 23.8247C9.46737 24.0395 9.46737 24.3878 9.68216 24.6026C9.89695 24.8173 10.2452 24.8173 10.46 24.6026L17.1421 17.9204L23.8243 24.6026C24.0391 24.8173 24.3873 24.8173 24.6021 24.6026C24.8169 24.3878 24.8169 24.0395 24.6021 23.8247L17.92 17.1426L24.6021 10.4604C24.8169 10.2456 24.8169 9.89739 24.6021 9.6826C24.3873 9.46781 24.0391 9.46781 23.8243 9.6826L17.1421 16.3648L10.46 9.6826C10.2452 9.46781 9.89695 9.46781 9.68216 9.6826C9.46737 9.89739 9.46737 10.2456 9.68216 10.4604L16.3643 17.1426L9.68216 23.8247Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.52ca69ec6782e5ccb6543f2b1bf2e59b.svg";
export { ForwardRef as ReactComponent };